class InvalidOriginException extends Error {
	constructor(origin) {
		super("Invalid origin in PostMessage: " + origin);
		this.name = "InvalidOriginException";
	}
}

export default InvalidOriginException;
